import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Reviews = () => {
  return (
    <section className="reviews my-3">
      <Container>
        <div className="trusted-by__header">
          <h3 className="text-center mb-4">Cosa dicono i nostri clienti</h3>
        </div>
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <div className="reviews__widget">
              <iframe
                src="https://www.mammachetest.com/mct_widget/index_slider.html?product_code=grDF45sk"
                width="100%"
                height="530"
                title="Recensioni SOS Dottore"
                style={{
                  maxWidth: '700px',
                  minWidth: '280px',
                  width: '100%',
                  border: 'none',
                  borderRadius: '8px',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                }}
                loading="lazy"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Reviews;
